
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/startup",
      function () {
        return require("private-next-pages/startup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/startup"])
      });
    }
  